import { createFileRoute } from "@tanstack/react-router";
import NicaAyer from "@/pages/NicaAyer";
import { loadResultsSummary } from "@/lib/results-seo";

export const Route = createFileRoute("/que-salio-ayer-en-la-nica")({
  loader: ({ context }) => loadResultsSummary(context.queryClient, 1),
  head: ({ loaderData }) => {
    const s = loaderData ?? { dateLabel: "", tica: "", nica: "" };
const title = `¿Qué salió ayer en la Nica? ${s.dateLabel}${s.nica ? `: ${s.nica}` : ""} | Loto Diaria`;
const description = `Qué salió ayer en la Nica (${s.dateLabel}): ${s.nica || "sorteos de 11am, 3pm y 9pm (6pm fines de semana)"}. Resultados de la Loto Diaria de Nicaragua de ayer.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: "https://tiemposhoy.com/que-salio-ayer-en-la-nica" },
        { name: "twitter:card", content: "summary" },
      ],
      links: [{ rel: "canonical", href: "https://tiemposhoy.com/que-salio-ayer-en-la-nica" }],
    };
  },
  component: NicaAyer,
});
